export default require('./EditDialog').default;
